import { Test } from "oc-e2e-testrunner";
import { resetArrangement } from "./utils";
import { ausrichtungCode } from "../components/TorEigenschaften";
import { equals } from "oc-e2e-testrunner/Assert";

export default {
  name: "TestAusrichtung",
};

const checkAusrichtung = (
  tor,
  einzeltorRichtung,
  gehflügel,
  anschlag,
  öffnung,
  füllungsseite,
  expectedAusrichtungCode
) => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 6;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.update3d();
  const s = agt.segmente[0];
  const elementProps = {
    füllungAuswahlwert: "SYSTEM WPC CLASSIC Sand",
    gehflügelAuswahlwert: ["Gehflügel_rechts", "Gehflügel_links"][gehflügel],
    öffnungAuswahlwert: ["Öffnung_nach_außen", "Öffnung_nach_innen"][öffnung],
    anschlagAuswahlwert: ["Anschlag_rechts", "Anschlag_links"][anschlag],
    füllungsseiteAuswahlwert: ["Füllungsseite_A", "Füllungsseite_B"][füllungsseite],
  };
  if (tor !== 2) {
    const element = agt.createElementFromJson({
      form: ["Einzeltor", "Doppeltor"][tor],
      ...elementProps,
    });
    s.addPart(element);
  } else {
    const element1 = agt.createElementFromJson({
      form: ["Einzeltor", "Doppeltor"][einzeltorRichtung],
      ...elementProps,
    });
    s.addPart(element1);
    const element2 = agt.createElementFromJson({
      form: ["Doppeltor", "Einzeltor"][einzeltorRichtung],
      ...elementProps,
    });
    s.addPart(element2);
  }
  agt.update3d();
  const element = s.getElemente()[0];
  const code = ausrichtungCode(element);
  equals(expectedAusrichtungCode, code);
};

// Dreifachtor
export const testAusrichtung1: Test = async () => checkAusrichtung(2, 0, 1, 1, 0, 0, "3lala");
export const testAusrichtung2: Test = async () => checkAusrichtung(2, 0, 1, 1, 0, 1, "3lalb");
export const testAusrichtung3: Test = async () => checkAusrichtung(2, 0, 0, 1, 0, 0, "3lara");
export const testAusrichtung4: Test = async () => checkAusrichtung(2, 0, 0, 1, 0, 1, "3larb");
export const testAusrichtung5: Test = async () => checkAusrichtung(2, 1, 1, 1, 1, 0, "3lila");
export const testAusrichtung6: Test = async () => checkAusrichtung(2, 1, 1, 1, 1, 1, "3lilb");
export const testAusrichtung7: Test = async () => checkAusrichtung(2, 1, 0, 1, 1, 0, "3lira");
export const testAusrichtung8: Test = async () => checkAusrichtung(2, 1, 0, 1, 1, 1, "3lirb");
export const testAusrichtung9: Test = async () => checkAusrichtung(2, 1, 1, 1, 0, 0, "3rala");
export const testAusrichtung10: Test = async () => checkAusrichtung(2, 1, 1, 1, 0, 1, "3ralb");
export const testAusrichtung11: Test = async () => checkAusrichtung(2, 1, 0, 1, 0, 0, "3rara");
export const testAusrichtung12: Test = async () => checkAusrichtung(2, 1, 0, 1, 0, 1, "3rarb");
export const testAusrichtung13: Test = async () => checkAusrichtung(2, 0, 1, 0, 1, 0, "3rila");
export const testAusrichtung14: Test = async () => checkAusrichtung(2, 0, 1, 0, 1, 1, "3rilb");
export const testAusrichtung15: Test = async () => checkAusrichtung(2, 0, 0, 0, 1, 0, "3rira");
export const testAusrichtung16: Test = async () => checkAusrichtung(2, 0, 0, 0, 1, 1, "3rirb");

// Doppeltor
export const testAusrichtung17: Test = async () => checkAusrichtung(1, 0, 1, 1, 0, 0, "dala");
export const testAusrichtung18: Test = async () => checkAusrichtung(1, 0, 1, 1, 0, 1, "dalb");
export const testAusrichtung19: Test = async () => checkAusrichtung(1, 0, 0, 1, 0, 0, "dara");
export const testAusrichtung20: Test = async () => checkAusrichtung(1, 0, 0, 1, 0, 1, "darb");
export const testAusrichtung21: Test = async () => checkAusrichtung(1, 0, 0, 1, 1, 0, "dila");
export const testAusrichtung22: Test = async () => checkAusrichtung(1, 0, 0, 1, 1, 1, "dilb");
export const testAusrichtung23: Test = async () => checkAusrichtung(1, 0, 1, 1, 1, 0, "dira");
export const testAusrichtung24: Test = async () => checkAusrichtung(1, 0, 1, 1, 1, 1, "dirb");

// Einzeltor
export const testAusrichtung25: Test = async () => checkAusrichtung(0, 0, 1, 1, 0, 0, "eala");
export const testAusrichtung26: Test = async () => checkAusrichtung(0, 0, 1, 1, 0, 1, "ealb");
export const testAusrichtung27: Test = async () => checkAusrichtung(0, 0, 0, 0, 0, 0, "eara");
export const testAusrichtung28: Test = async () => checkAusrichtung(0, 0, 0, 0, 0, 1, "earb");
export const testAusrichtung29: Test = async () => checkAusrichtung(0, 0, 1, 0, 1, 0, "eila");
export const testAusrichtung30: Test = async () => checkAusrichtung(0, 0, 1, 0, 1, 1, "eilb");
export const testAusrichtung31: Test = async () => checkAusrichtung(0, 0, 0, 1, 1, 0, "eira");
export const testAusrichtung32: Test = async () => checkAusrichtung(0, 0, 0, 1, 1, 1, "eirb");
